import { forkJoin, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BaseFlowComponent } from "../base-flow-component/base-flow-component";
import { Component } from "@angular/core";
import { CompleteActivityResultPropertiesData } from "./complete-activity-result-properties-data";
import { ActivitiesService } from "../../../../services/activities.service";
import { PopupSettings } from "@progress/kendo-angular-dropdowns";
import { RequestsService } from "../../../../services/requests.service";

@Component({
    selector: 'complete-activity-result-properties',
    templateUrl: './complete-activity-result-properties.component.html',
    styleUrls: ['./complete-activity-result-properties.component.scss',
        '../../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss']
})
export class CompleteActivityResultPropertiesComponent extends 
    BaseFlowComponent<CompleteActivityResultPropertiesData> {

    unsetBIOReasonId: number;

    constructor(
        private activitiesService: ActivitiesService,
        private requestsService: RequestsService
    ) {
        super();
    }

    popupSettings: PopupSettings = {
		popupClass: 'custom-popup'
	};

    initData() {
        if (this.data.activityResults.length == 1) {
            this.data.activityResultIds = [this.data.activityResults[0].id];
        }
        if (this.data.completedDateTime == null) {
            this.data.completedDateTime = new Date();
        }

        if (this.data.unsetBIOReason != null) {
            let unsetBioReason = this.data.unsetBIOReasons.find(x => x.name == this.data.unsetBIOReason);
            this.unsetBIOReasonId = unsetBioReason != null ? unsetBioReason.id : null;
        }

        this.resetUnsetBIOReasonIfBIOEnabled();
    }

    onSetBIOChanged(setBIO: boolean): void {
        this.data.setBIO = setBIO;
        this.resetUnsetBIOReasonIfBIOEnabled();
    }
    
    saveChanges(): Observable<CompleteActivityResultPropertiesData> {
        const updateActivity$ = this.activitiesService.update(this.data.activity, null, false, true);

        if (this.data.requireSetBIO) {
            let unsetBioReason = this.data.unsetBIOReasons.find(x => x.id == this.unsetBIOReasonId);
            this.data.unsetBIOReason = unsetBioReason != null ? unsetBioReason.name : null;
            const updateTidConfiguration$ = this.requestsService.updateTidConfiguration(
                this.data.activity.requestId, this.data.setBIO, this.data.unsetBIOReason);

            return forkJoin([updateActivity$, updateTidConfiguration$]).pipe(
                map(() => this.data)
            );
        }

        return updateActivity$.pipe(map(() => this.data));
    }

    get formCompleted(): boolean {
        return this.data.activityResultIds.length > 0 && this.data.completedDateTime && 
            this.data.activity.finishActivityComment && this.data.activity.finishActivityComment.trim().length > 0 &&
            this.bioCompleted;
    }

    get bioCompleted(): boolean {
        return !this.data.requireSetBIO || this.data.setBIO || (!this.data.setBIO && this.unsetBIOReasonId != null);
    }

    private resetUnsetBIOReasonIfBIOEnabled(): void {
        if (this.data.setBIO) {
					this.unsetBIOReasonId = null;
        }
    }
}
